import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
//import '!style-loader!css-loader!bootstrap/dist/css/bootstrap.css';
import "style.css";

ReactDOM.render(<App />, document.getElementById('app'));
